﻿export class NUtils {
    // BigInt[]
    static compare = [
        BigInt('1000'),
        BigInt('1000000'),
        BigInt('1000000000'),
        BigInt('1000000000000'),
        BigInt('1000000000000000'),
        BigInt('1000000000000000000'),
        BigInt('1000000000000000000000'),
        BigInt('1000000000000000000000000'),
        BigInt('1000000000000000000000000000'),
        BigInt('1000000000000000000000000000000'),
        BigInt('1000000000000000000000000000000000'),
        BigInt('1000000000000000000000000000000000000'),
        BigInt('1000000000000000000000000000000000000000'),
        BigInt('1000000000000000000000000000000000000000000'),
        BigInt('1000000000000000000000000000000000000000000000'),
        BigInt('1000000000000000000000000000000000000000000000000'),
        BigInt('1000000000000000000000000000000000000000000000000000'),
        BigInt('1000000000000000000000000000000000000000000000000000000'),
        BigInt('1000000000000000000000000000000000000000000000000000000000'),
    ];

    // BigInt[]
    static divider = [
        BigInt("100"),
        BigInt("100000"),
        BigInt("100000000"),
        BigInt("100000000000"),
        BigInt("100000000000000"),
        BigInt("100000000000000000"),
        BigInt("100000000000000000000"),
        BigInt("100000000000000000000000"),
        BigInt("100000000000000000000000000"),
        BigInt("100000000000000000000000000000"),
        BigInt("100000000000000000000000000000000"),
        BigInt("100000000000000000000000000000000000"),
        BigInt("100000000000000000000000000000000000000"),
        BigInt("100000000000000000000000000000000000000000"),
        BigInt("100000000000000000000000000000000000000000000"),
        BigInt("100000000000000000000000000000000000000000000000"),
        BigInt("100000000000000000000000000000000000000000000000000"),
        BigInt("100000000000000000000000000000000000000000000000000000"),
        BigInt("100000000000000000000000000000000000000000000000000000000"),
    ];

    // string[]
    static letter = [
        "K",
        "M",
        "B",
        "T",
        "aa",
        "ab",
        "ac",
        "ad",
        "ae",
        "af",
        "ag",
        "ah",
        "ai",
        "aj",
        "ak",
        "al",
        "am",
        "an",
        "ao"
    ];

    static FormatMoney(number) {
        number = BigInt(~~number);
        if (number < this.compare[0]) return number.toString();
        for (let i = 0; i < this.compare.length - 1; i++) {
            if (number >= this.compare[i] && number < this.compare[i + 1]) {
                let r = number / this.divider[i];
                let str = r.toString();
                let n1 = str.substr(0, str.length - 1);
                let n2 = str.substr(-1);
                return n1 + (n2 === '0' ? "" : "." + n2) + this.letter[i];
            }
        }
        return "Inf.";
    }

    static stringsToBigInts(arr) {
        return arr.map(str => BigInt(str || '0'));
    }

    static bigIntsToStrings(ints) {
        return ints.map(n => (n || 0).toString());
    }

    static FormatSecondsToTimeArray(seconds) {
        let h = Math.floor(seconds / 3600);
        let m = Math.floor((seconds % 3600) / 60);
        let s = ~~(seconds % 60);
        return [h, m, s];
    }

    static FormatSecondsToTime(seconds) {
        seconds = Math.abs(seconds);
        let [h, m, s] = this.FormatSecondsToTimeArray(seconds);
        let str = "";
        if (seconds >= 3600) str += String(h) + "h ";
        if (seconds >= 60) str += String(m).padStart(2, "0") + "m ";
        str += String(s).padStart(2, "0") + "s";
        return str;
    }
}

window.NUtils = NUtils; // XXX: debug
